module.exports = __webpack_public_path__ + "img/dp_lp_pc_fr_copy.c46ee72a.png";